import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import { useLocalStorage, useDebounce } from 'react-use';
import { Sheet, SpreadsheetComponent } from '@syncfusion/ej2-react-spreadsheet';
import {
  Button,
  Card,
  Col,
  Form,
  Row,
} from 'react-bootstrap';
import useNotif from 'hooks/use-notify-hook';
import AnswerRepository from 'repository/Answer.js';


function Table({ schedule, answer, scores, isReadonly, children}) {

  let spreadsheet = useRef(null);
  const spreadsheetRef = React.useRef(null);

  const [auth] = useLocalStorage('authenticated');
  const [notif, dispatchNotif] = useNotif();
  const [data, setData] = useState(answer.ANSWER_DESC);
  const [evaluation, setEvaluation] = useState(answer?.EVALUATE_DESC ?? ``);
  const [explanation , setExplanation] = useState(answer.ADD_EXPLAN ?? '');
  const [attachments, setAttachments] = useState(answer?.answerAttachments ?? []);
  const [sheetName, setSheetName] = useState(answer.question.JSON_TABLE);
  const [scheduleId, setScheduleId] = useState(schedule.SCHEDULE_ID);
  const [openTable, setOpenTable] = useState(false);

  const repository = new AnswerRepository(auth.token);

  const handleTest = async () => {
    setOpenTable(true);
    const response = await fetch('https://siami.umn.ac.id/api/siami/schedules/'+scheduleId+'/download');
    const fileBlob = await response.blob(); // convert the excel file to blob
    const file = new File([fileBlob], 'Sample.xlsx');
    let spreadsheets = spreadsheetRef.current;
    if (spreadsheets) {
        spreadsheets.open({ file }); // open the file into Spreadsheet]
    }
  }


  const handleCreated = async () => {

    if (data === null || data === undefined) return;
    if (!spreadsheet.current) return;

    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}answers/${answer.ANSWER_ID}/spreadsheet`,
    );

    spreadsheet.current.openFromJson({ file: response.data });
  }

  const [, cancelEvaluation] = useDebounce(async () => {

    const data = {
      EVALUATE_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
      EVALUATE_BY: auth.employee.EMP_ID,
      EVALUATE_DESC: evaluation,
    };

    const response = await repository.answer(answer.ANSWER_ID, data);

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

  }, 2000, [evaluation]);

  useEffect(() => {
    cancelEvaluation();
  }, []);

  return (
    <Row>
      {notif}
      <Col md="12">
        <Card>
          <Card.Header>
            <Card.Title style={{fontWeight:'bold', fontSize:'20px', marginBottom:10}} as="h5">{answer.question.QUESTION_CODE}. <a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
            <div style={{whiteSpace: 'pre-wrap', marginLeft:18, marginTop:5, fontSize:'17px'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} />
            <hr></hr>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="12" >
                <Form.Group>
                  <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Score</Form.Label>
                  <p><b>{scores.find(item => item.INDEX_ID === answer.INDEX_ID)?.SCORE_INDEX ?? `n/a`}</b></p>
                </Form.Group>
                {!openTable ?
                  <Form.Group>
                    <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Auditee's Answer</Form.Label>
                    <SpreadsheetComponent
                      ref={spreadsheet}
                      allowEditing={false}
                      showFormulaBar={false}
                      showSheetTabs={false}
                      created={handleCreated}
                    />
                  </Form.Group>

                : ''}
                {openTable ?
                  <Form.Group>
                    <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Auditee's Answer</Form.Label>
                    <SpreadsheetComponent ref={spreadsheetRef} openUrl='https://services.syncfusion.com/react/production/api/spreadsheet/open'/>
                  </Form.Group>
                : ''}
                <Form.Group>
                  <Button variant="info" size="sm" onClick={handleTest}>View Complete Table / {sheetName}</Button>
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Additional Explanation</Form.Label>
                  <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answer.ADD_EXPLAN}} />
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Evaluation</Form.Label>
                  <Form.Control
                    value={evaluation}
                    onChange={({ target: {value }}) => setEvaluation(value)}
                    as="textarea"
                    rows={3}
                    disabled={isReadonly}
                    isInvalid={evaluation?.length > 4000}
                  />
                  <Form.Text id="passwordHelpBlock" muted>
                    Total characters: {evaluation?.length ?? 0} / 4000
                  </Form.Text>
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{fontSize:'17px'}}>Attachment(s)</Form.Label>
                  {attachments && attachments.length > 0
                    ? attachments.map((attachment, key) => (
                      <div key={key} className="font-icon-detail">
                        <i className="nc-icon nc-attach-87"></i>{' '}
                        <a href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`} target="_blank" rel="noopener noreferrer">
                          {attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}
                        </a>
                      </div>
                    ))
                    : <p>No attachment uploaded.</p>
                  }
                </Form.Group>
              </Col>
              {/* <Col md="4">
                <Form.Group>
                  <Form.Label>Score</Form.Label>
                  <p>{scores.find(item => item.INDEX_ID === answer.INDEX_ID)?.INDEX_ID ?? `n/a`}</p>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Attachment(s)</Form.Label>
                  {attachments && attachments.length > 0
                    ? attachments.map((attachment, key) => (
                      <div key={key} className="font-icon-detail">
                        <i className="nc-icon nc-attach-87"></i>{' '}
                        <a href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`} target="_blank" rel="noopener noreferrer">
                          {attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}
                        </a>
                      </div>
                    ))
                    : <p>No attachment uploaded.</p>
                  }
                </Form.Group>
              </Col> */}
            </Row>
            <Row>
              <Col md="12">
                {children}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default Table;